var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imglst && _vm.imglst.length > 0)?_c('div',{staticClass:"home-banner"},[_c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":2500,"indicator-color":"white"}},_vm._l((_vm.imglst),function(item,index){return _c('van-swipe-item',{key:index},[_c('img',{attrs:{"src":item.url}})])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }